import React from 'react';

import "./SelectableCard.css";

const SelectableCard = ({ item, selected, onSelect }) => {
  const cardClassName = selected ? 'card-tur selected' : ' card-tur';

  return (
    <div className={cardClassName} onClick={() => onSelect(item)}>
      <br />
      <div>
        {item.ncosto}
      </div>      
      <div>
        ${item.costo}
      </div>
    </div>
  );
};

export default SelectableCard;